import { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'

export default function NewProjectDialog({ open, onClose, onSubmit }) {
  const [name, setName] = useState('')
  const [instructions, setInstructions] = useState('')
  const reset = () => {
    setName('')
    setInstructions('')
  }
  const handleClose = () => {
    reset()
    onClose()
  }
  const handleSubmit = (event) => {
    event.preventDefault()
    const trimmed = name.trim()
    if (!trimmed) return
    onSubmit({ name: trimmed, instructions: instructions.trim() || null })
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>New project</DialogTitle>
        <DialogContent sx={{ display: 'grid', gap: 2, pt: 1 }}>
          <TextField
            autoFocus
            label="Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
          <TextField
            label="Instructions"
            value={instructions}
            onChange={(event) => setInstructions(event.target.value)}
            multiline
            minRows={3}
          />
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={handleClose}>Cancel</Button>
          <Button type="submit" variant="contained">Create</Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
